import _styled, { default as _styled2, default as _styled3 } from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { sortBy, uniqBy } from "lodash-es";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import defined from "terriajs-cesium/Source/Core/defined";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import { Category, DataSourceAction } from "../../../Core/AnalyticEvents/analyticEvents";
import TerriaError from "../../../Core/TerriaError";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import getDereferencedIfExists from "../../../Core/getDereferencedIfExists";
import getPath from "../../../Core/getPath";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin, { getName } from "../../../ModelMixins/CatalogMemberMixin";
import DiffableMixin from "../../../ModelMixins/DiffableMixin";
import ExportableMixin from "../../../ModelMixins/ExportableMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import SearchableItemMixin from "../../../ModelMixins/SearchableItemMixin";
import TimeVarying from "../../../ModelMixins/TimeVarying";
import CameraView from "../../../Models/CameraView";
import SplitItemReference from "../../../Models/Catalog/CatalogReferences/SplitItemReference";
import addUserCatalogMember from "../../../Models/Catalog/addUserCatalogMember";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import hasTraits from "../../../Models/Definition/hasTraits";
import getAncestors from "../../../Models/getAncestors";
import AnimatedSpinnerIcon from "../../../Styled/AnimatedSpinnerIcon";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import Icon, { StyledIcon } from "../../../Styled/Icon";
import Ul from "../../../Styled/List";
import SplitterTraits from "../../../Traits/TraitsClasses/SplitterTraits";
import { exportData } from "../../Preview/ExportData";
import LazyItemSearchTool from "../../Tools/ItemSearchTool/LazyItemSearchTool";
import WorkbenchButton from "../WorkbenchButton";
import { enableAllControls, isControlEnabled } from "./WorkbenchControls";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BoxViewingControl = styled(Box).attrs({
  centered: true,
  left: true,
  justifySpaceBetween: true
}).withConfig({
  displayName: "ViewingControls__BoxViewingControl",
  componentId: "sc-7nmh19-0"
})([""]);
const ViewingControlMenuButton = styled(RawButton).attrs({
  // primaryHover: true
}).withConfig({
  displayName: "ViewingControls__ViewingControlMenuButton",
  componentId: "sc-7nmh19-1"
})(["color:", ";background-color:", ";", "{width:35px;}svg{fill:", ";width:18px;height:18px;}& > span{}border-radius:0;width:124px;min-height:32px;display:block;&:hover,&:focus{color:", ";background-color:", ";svg{fill:", ";}}"], props => props.theme.textDarker, props => props.theme.textLight, StyledIcon, props => props.theme.textDarker, props => props.theme.textLight, props => props.theme.colorPrimary, props => props.theme.textLight);
const ViewingControls = observer(props => {
  const {
    viewState,
    item,
    controls = enableAllControls
  } = props;
  const {
    t
  } = useTranslation();
  const [isMenuOpen, setIsOpen] = useState(false);
  const [isMapZoomingToCatalogItem, setIsMapZoomingToCatalogItem] = useState(false);
  useEffect(() => {
    const hideMenu = () => {
      setIsOpen(false);
    };
    window.addEventListener("click", hideMenu);
    return () => window.removeEventListener("click", hideMenu);
  }, [viewState]);
  const removeFromMap = useCallback(() => {
    var _viewState$terria$ana;
    const terria = viewState.terria;
    terria.workbench.remove(item);
    terria.removeSelectedFeaturesForModel(item);
    if (TimeVarying.is(item)) viewState.terria.timelineStack.remove(item);
    (_viewState$terria$ana = viewState.terria.analytics) === null || _viewState$terria$ana === void 0 || _viewState$terria$ana.logEvent(Category.dataSource, DataSourceAction.removeFromWorkbench, getPath(item));
  }, [item, viewState]);
  const zoomTo = useCallback(() => {
    var _item$idealZoom, _item$idealZoom2, _item$idealZoom3, _item$idealZoom4, _item$idealZoom5, _item$idealZoom6, _item$idealZoom$lookA, _item$idealZoom7, _item$rectangle, _item$rectangle2;
    const viewer = viewState.terria.currentViewer;
    if (!MappableMixin.isMixedInto(item)) return;
    let zoomToView = item;
    function vectorToJson(vector) {
      if (typeof (vector === null || vector === void 0 ? void 0 : vector.x) === "number" && typeof (vector === null || vector === void 0 ? void 0 : vector.y) === "number" && typeof (vector === null || vector === void 0 ? void 0 : vector.z) === "number") {
        return {
          x: vector.x,
          y: vector.y,
          z: vector.z
        };
      } else {
        return undefined;
      }
    }

    // camera is likely used more often than lookAt.
    const theWest = item === null || item === void 0 || (_item$idealZoom = item.idealZoom) === null || _item$idealZoom === void 0 || (_item$idealZoom = _item$idealZoom.camera) === null || _item$idealZoom === void 0 ? void 0 : _item$idealZoom.west;
    const theEast = item === null || item === void 0 || (_item$idealZoom2 = item.idealZoom) === null || _item$idealZoom2 === void 0 || (_item$idealZoom2 = _item$idealZoom2.camera) === null || _item$idealZoom2 === void 0 ? void 0 : _item$idealZoom2.east;
    const theNorth = item === null || item === void 0 || (_item$idealZoom3 = item.idealZoom) === null || _item$idealZoom3 === void 0 || (_item$idealZoom3 = _item$idealZoom3.camera) === null || _item$idealZoom3 === void 0 ? void 0 : _item$idealZoom3.north;
    const theSouth = item === null || item === void 0 || (_item$idealZoom4 = item.idealZoom) === null || _item$idealZoom4 === void 0 || (_item$idealZoom4 = _item$idealZoom4.camera) === null || _item$idealZoom4 === void 0 ? void 0 : _item$idealZoom4.south;
    if (isDefined((_item$idealZoom5 = item.idealZoom) === null || _item$idealZoom5 === void 0 || (_item$idealZoom5 = _item$idealZoom5.lookAt) === null || _item$idealZoom5 === void 0 ? void 0 : _item$idealZoom5.targetLongitude) && isDefined((_item$idealZoom6 = item.idealZoom) === null || _item$idealZoom6 === void 0 || (_item$idealZoom6 = _item$idealZoom6.lookAt) === null || _item$idealZoom6 === void 0 ? void 0 : _item$idealZoom6.targetLatitude) && ((_item$idealZoom$lookA = (_item$idealZoom7 = item.idealZoom) === null || _item$idealZoom7 === void 0 || (_item$idealZoom7 = _item$idealZoom7.lookAt) === null || _item$idealZoom7 === void 0 ? void 0 : _item$idealZoom7.range) !== null && _item$idealZoom$lookA !== void 0 ? _item$idealZoom$lookA : 0) >= 0) {
      // No value checking here. Improper values can lead to unexpected results.
      const lookAt = {
        targetLongitude: item.idealZoom.lookAt.targetLongitude,
        targetLatitude: item.idealZoom.lookAt.targetLatitude,
        targetHeight: item.idealZoom.lookAt.targetHeight,
        heading: item.idealZoom.lookAt.heading,
        pitch: item.idealZoom.lookAt.pitch,
        range: item.idealZoom.lookAt.range
      };

      // In the case of 2D viewer, it zooms to rectangle area approximated by the camera view parameters.
      zoomToView = CameraView.fromJson({
        lookAt: lookAt
      });
    } else if (theWest && theEast && theNorth && theSouth) {
      var _item$idealZoom8, _item$idealZoom9, _item$idealZoom0;
      const thePosition = vectorToJson(item === null || item === void 0 || (_item$idealZoom8 = item.idealZoom) === null || _item$idealZoom8 === void 0 || (_item$idealZoom8 = _item$idealZoom8.camera) === null || _item$idealZoom8 === void 0 ? void 0 : _item$idealZoom8.position);
      const theDirection = vectorToJson(item === null || item === void 0 || (_item$idealZoom9 = item.idealZoom) === null || _item$idealZoom9 === void 0 || (_item$idealZoom9 = _item$idealZoom9.camera) === null || _item$idealZoom9 === void 0 ? void 0 : _item$idealZoom9.direction);
      const theUp = vectorToJson(item === null || item === void 0 || (_item$idealZoom0 = item.idealZoom) === null || _item$idealZoom0 === void 0 || (_item$idealZoom0 = _item$idealZoom0.camera) === null || _item$idealZoom0 === void 0 ? void 0 : _item$idealZoom0.up);

      // No value checking here. Improper values can lead to unexpected results.
      const camera = {
        west: theWest,
        east: theEast,
        north: theNorth,
        south: theSouth,
        position: thePosition,
        direction: theDirection,
        up: theUp
      };
      zoomToView = CameraView.fromJson(camera);
    } else if (((_item$rectangle = item.rectangle) === null || _item$rectangle === void 0 ? void 0 : _item$rectangle.east) !== undefined && ((_item$rectangle2 = item.rectangle) === null || _item$rectangle2 === void 0 ? void 0 : _item$rectangle2.west) !== undefined && item.rectangle.east - item.rectangle.west >= 360) {
      zoomToView = viewState.terria.mainViewer.homeCamera;
      console.log("Extent is wider than world so using homeCamera.");
    }
    setIsMapZoomingToCatalogItem(true);
    viewer.zoomTo(zoomToView).finally(() => {
      setIsMapZoomingToCatalogItem(false);
    });
  }, [item, viewState]);
  const splitItem = useCallback(() => {
    const terria = item.terria;
    const splitRef = new SplitItemReference(createGuid(), terria);
    runInAction(async () => {
      if (!hasTraits(item, SplitterTraits, "splitDirection")) return;
      if (item.splitDirection === SplitDirection.NONE) {
        item.setTrait(CommonStrata.user, "splitDirection", SplitDirection.RIGHT);
      }
      splitRef.setTrait(CommonStrata.user, "splitSourceItemId", item.uniqueId);
      terria.addModel(splitRef);
      terria.showSplitter = true;
      await splitRef.loadReference();
      runInAction(() => {
        const target = splitRef.target;
        if (target) {
          target.setTrait(CommonStrata.user, "name", t("splitterTool.workbench.copyName", {
            name: getName(item)
          }));

          // Set a direction opposite to the original item
          target.setTrait(CommonStrata.user, "splitDirection", item.splitDirection === SplitDirection.LEFT ? SplitDirection.RIGHT : SplitDirection.LEFT);
        }
      });

      // Add it to terria.catalog, which is required so the new item can be shared.
      addUserCatalogMember(terria, splitRef, {
        open: false
      });
    });
  }, [item, t]);
  const openDiffTool = useCallback(() => {
    viewState.openTool({
      toolName: "Difference",
      getToolComponent: () => import("../../Tools/DiffTool/DiffTool").then(m => m.default),
      params: {
        sourceItem: item
      }
    });
  }, [item, viewState]);
  const searchItem = useCallback(() => {
    runInAction(() => {
      if (!SearchableItemMixin.isMixedInto(item)) return;
      let itemSearchProvider;
      try {
        itemSearchProvider = item.createItemSearchProvider();
      } catch (error) {
        viewState.terria.raiseErrorToUser(error);
        return;
      }
      viewState.openTool({
        toolName: "Search Item",
        getToolComponent: () => LazyItemSearchTool,
        params: {
          item,
          itemSearchProvider,
          viewState
        }
      });
    });
  }, [item, viewState]);
  const previewItem = useCallback(async () => {
    // Open up all the parents (doesn't matter that this sets it to enabled as well because it already is).
    getAncestors(item).map(item => getDereferencedIfExists(item)).forEach(group => {
      runInAction(() => {
        group.setTrait(CommonStrata.user, "isOpen", true);
      });
    });
    viewState.viewCatalogMember(item).then(result => result.raiseError(viewState.terria));
  }, [item, viewState]);
  const exportDataClicked = useCallback(() => {
    if (!ExportableMixin.isMixedInto(item)) return;
    exportData(item).catch(e => {
      item.terria.raiseErrorToUser(e);
    });
  }, [item]);
  const viewingControls = useMemo(() => {
    if (!CatalogMemberMixin.isMixedInto(item)) {
      return [];
    }

    // Global viewing controls (usually defined by plugins).
    const globalViewingControls = filterOutUndefined(viewState.globalViewingControlOptions.map(generateViewingControlForItem => {
      try {
        return generateViewingControlForItem(item);
      } catch (err) {
        TerriaError.from(err).log();
        return undefined;
      }
    }));
    // Item specific viewing controls
    const itemViewingControls = item.viewingControls;

    // Collate list, unique by id and sorted by name
    return sortBy(uniqBy([...itemViewingControls, ...globalViewingControls], "id"), "name").filter(_ref => {
      let {
        id
      } = _ref;
      // Exclude disabled controls
      return isControlEnabled(controls, id);
    });
  }, [item, controls, viewState.globalViewingControlOptions]);
  const renderViewingControlsMenu = () => {
    const canSplit = controls.compare && !item.terria.configParameters.disableSplitter && hasTraits(item, SplitterTraits, "splitDirection") && hasTraits(item, SplitterTraits, "disableSplitter") && !item.disableSplitter && defined(item.splitDirection) && item.terria.currentViewer.canShowSplitter;
    const handleOnClick = viewingControl => {
      try {
        viewingControl.onClick(viewState);
      } catch (err) {
        viewState.terria.raiseErrorToUser(TerriaError.from(err));
      }
    };
    return /*#__PURE__*/_jsxs("ul", {
      children: [viewingControls.map(viewingControl => /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: () => handleOnClick(viewingControl),
          title: viewingControl.iconTitle,
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, _objectSpread({}, viewingControl.icon)), /*#__PURE__*/_jsx("span", {
              children: viewingControl.name
            })]
          })
        })
      }, viewingControl.id)), canSplit ? /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: splitItem,
          title: t("workbench.splitItemTitle"),
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.compare
            }), /*#__PURE__*/_jsx("span", {
              children: t("workbench.splitItem")
            })]
          })
        })
      }, "workbench.splitItem") : null, controls.difference && viewState.useSmallScreenInterface === false && DiffableMixin.isMixedInto(item) && !item.isShowingDiff && item.canDiffImages ? /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: openDiffTool,
          title: t("workbench.diffImageTitle"),
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.difference
            }), /*#__PURE__*/_jsx("span", {
              children: t("workbench.diffImage")
            })]
          })
        })
      }, "workbench.diffImage") : null, controls.exportData && viewState.useSmallScreenInterface === false && ExportableMixin.isMixedInto(item) && item.canExportData ? /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: exportDataClicked,
          title: t("workbench.exportDataTitle"),
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.upload
            }), /*#__PURE__*/_jsx("span", {
              children: t("workbench.exportData")
            })]
          })
        })
      }, "workbench.exportData") : null, controls.search && viewState.useSmallScreenInterface === false && SearchableItemMixin.isMixedInto(item) && item.canSearch ? /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: searchItem,
          title: t("workbench.searchItemTitle"),
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.search
            }), /*#__PURE__*/_jsx("span", {
              children: t("workbench.searchItem")
            })]
          })
        })
      }, "workbench.searchItem") : null, /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ViewingControlMenuButton, {
          onClick: removeFromMap,
          title: t("workbench.removeFromMapTitle"),
          children: /*#__PURE__*/_jsxs(BoxViewingControl, {
            children: [/*#__PURE__*/_jsx(StyledIcon, {
              glyph: Icon.GLYPHS.cancel
            }), /*#__PURE__*/_jsx("span", {
              children: t("workbench.removeFromMap")
            })]
          })
        })
      }, "workbench.removeFromMap")]
    });
  };
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsxs(_StyledUl, {
      gap: 2,
      children: [/*#__PURE__*/_jsx(WorkbenchButton, {
        onClick: zoomTo,
        title: t("workbench.zoomToTitle"),
        disabled: !controls.idealZoom ||
        // disabled if the item cannot be zoomed to or if a zoom is already in progress
        MappableMixin.isMixedInto(item) && item.disableZoomTo || isMapZoomingToCatalogItem === true,
        iconElement: () => isMapZoomingToCatalogItem ? /*#__PURE__*/_jsx(AnimatedSpinnerIcon, {}) : /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.search
        }),
        children: t("workbench.zoomTo")
      }), /*#__PURE__*/_jsx(WorkbenchButton, {
        onClick: previewItem,
        title: t("workbench.previewItemTitle"),
        iconElement: () => /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.about
        }),
        disabled: !controls.aboutData || CatalogMemberMixin.isMixedInto(item) && item.disableAboutData,
        children: t("workbench.previewItem")
      }), /*#__PURE__*/_jsx(_StyledWorkbenchButton, {
        onClick: e => {
          e.stopPropagation();
          if (isMenuOpen) {
            setIsOpen(false);
          } else {
            setIsOpen(true);
          }
        },
        title: t("workbench.showMoreActionsTitle"),
        iconOnly: true,
        iconElement: () => /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.menuDotted
        })
      })]
    }), isMenuOpen && /*#__PURE__*/_jsx(_StyledBox, {
      children: renderViewingControlsMenu()
    })]
  });
});
ViewingControls.displayName = "ViewingControls";
export default ViewingControls;
var _StyledUl = styled(Ul).withConfig({
  displayName: "ViewingControls___StyledUl",
  componentId: "sc-7nmh19-2"
})(["list-style:none;padding-left:0;margin:0;width:100%;position:relative;display:flex;justify-content:space-between;li{display:block;float:left;box-sizing:border-box;}& > button:last-child{margin-right:0;}"]);
var _StyledWorkbenchButton = styled(WorkbenchButton).withConfig({
  displayName: "ViewingControls___StyledWorkbenchButton",
  componentId: "sc-7nmh19-3"
})(["flex-grow:0;"]);
var _StyledBox = styled(Box).withConfig({
  displayName: "ViewingControls___StyledBox",
  componentId: "sc-7nmh19-4"
})(["position:absolute;z-index:100;right:0;top:0;top:32px;top:42px;padding:0;margin:0;ul{list-style:none;}"]);